/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import styles from './NonVehicleYMMERedesign.module.scss';
import NextImage from '@/components/NextImage';
import { useLabels } from '@/hooks/useLabels';
import { Icon } from '@az/starc-ui';
import { ChevronRight } from '@az/starc-ui-icons';
import { getVehicleTypeIcon } from '../../utils/getVehicleTypeIcon';

const warningIconSrc = '/images/icon-fitment-warning-orange.svg';

const labelMap = {
  lblInlineEntryPointTitle: 'label_InlineEntryPointTitle',
  lblInlineEntryPointSubtitle: 'label_InlineEntryPointSubtitle',
  lblAddVehicleYear: 'button_YMME_Inline_AddVehicleYear',
  lblFitmentWarning: 'label_FitmentWarning',
};

type Props = {
  openDefaultYMME: () => void;
};

export const NonVehicleYMMERedesign = ({ openDefaultYMME }: Props) => {
  const labels = useLabels(labelMap);
  const vehicleTypeIcon = getVehicleTypeIcon(undefined, 'desktop', 'base');

  return (
    <div className={styles.container}>
      <div className={styles.infoSection}>
        <div className={styles.iconContainer} data-testid="ymme-content-title">
          <NextImage src={vehicleTypeIcon} alt="" aria-hidden="true" width={32} height={23} />
          <div className={styles.warningBadge}>
            <NextImage src={warningIconSrc} alt="" aria-hidden="true" width={16} height={16} />
          </div>
          <span className="sr-only">{labels.lblFitmentWarning}</span>
        </div>
        <div className={styles.textSection}>
          <p className={styles.title}>{labels.lblInlineEntryPointTitle}</p>
          <p className={styles.subtitle}>{labels.lblInlineEntryPointSubtitle}</p>
        </div>
      </div>
      <div className={styles.ctaSection}>
        <button type="button" className={styles.ctaButton} onClick={openDefaultYMME}>
          <span className={styles.ctaText}>{labels.lblAddVehicleYear}</span>
          <div className={styles.ctaChevronSection}>
            <div className={styles.divider} aria-hidden="true" />
            <Icon svg={ChevronRight} size={6} color="black" />
          </div>
        </button>
      </div>
    </div>
  );
};
